import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const DATA_FILE_PATH = "/uploads/data.json";
const FOOTER_IMAGE_PATH = "/uploads/Assets/footer.webp";

const slugify = (text) => {
    return text
        .toLowerCase()
        .trim()
        .replace(/&/g, 'and')
        .replace(/[^\w\s-]/g, '')
        .replace(/[\s_-]+/g, '-')
        .replace(/^-+|-+$/g, '');
};

export default function Footer() {
    const [industries, setIndustries] = useState([]);
    const [gameCategories, setGameCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetch(DATA_FILE_PATH)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Failed to fetch data: ${response.statusText}`);
                }
                return response.json();
            })
            .then(fetchedData => {
                const industryNames = fetchedData.Industries.map(item => item.name);
                setIndustries(industryNames);
                const categoryNames = fetchedData.Categories.map(item => item.name);
                setGameCategories(categoryNames);
            })
            .catch(err => {
                console.error("Error loading footer data:", err);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    if (isLoading) {
        return <div className="h-20 bg-gray-900"></div>;
    }

    return (
        <section className="relative">
            <img
                src={FOOTER_IMAGE_PATH}
                className="absolute inset-0 h-full w-full object-cover z-0"
                alt="background-image"
            />

            <div className="relative z-10 text-white pt-16 pb-8">

                <div className="mx-auto max-w-6xl px-4 sm:px-6">

                    <div className="flex flex-col xl-custom:flex-row xl-custom:justify-between mb-8">

                        <div className="flex flex-col xl-custom:flex-row xl-custom:gap-x-48 xl-custom:justify-between">
                            <div className="flex flex-col mb-8 xl-custom:mb-0">
                                <h3 className="text-white font-uber font-medium text-[18px] leading-[24px] mb-5">Industries</h3>
                                {industries.map((industry, index) => (
                                    <Link
                                        key={index}
                                        to={`/industries/${slugify(industry)}`}
                                        className="mb-2 text-inherit font-uber font-normal text-[14px] leading-[20px] hover:text-gray-400"
                                    >
                                        {industry}
                                    </Link>
                                ))}
                            </div>

                            <div className="flex flex-col mb-8 xl-custom:mb-0">
                                <h3 className="text-white font-uber font-medium text-[18px] leading-[24px] mb-5">Game Categories</h3>
                                {gameCategories.map((category, index) => (
                                    <Link
                                        key={index}
                                        to={`/games/${slugify(category)}`}
                                        className="mb-2 text-inherit font-uber font-normal text-[14px] leading-[20px] hover:text-gray-400"
                                    >
                                        {category}
                                    </Link>
                                ))}
                            </div>
                        </div>

                        <div className="flex flex-col xl-custom:flex-row xl-custom:justify-end xl-custom:gap-x-48">
                            <div className="flex flex-col mb-8 xl-custom:mb-0">
                                <Link
                                    to="/analytics"
                                    className="text-white font-uber font-medium text-[18px] leading-[24px] mb-5 hover:text-gray-400 cursor-pointer"
                                >
                                    Analytics
                                </Link>
                            </div>

                            <div className="flex flex-col">
                                <Link to="/case-study" className="text-white font-uber font-medium text-[18px] leading-[24px] mb-5 hover:text-gray-400 cursor-pointer">Case Study</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}